<div class="section">
    <div data-qa-id="locums-state-licenses-label" class="nova__label">State License/s</div>
    <div data-qa-id="locums-state-licenses-value">
        <label *ngIf="stateLicenses?.length === 0" data-qa-id="locums-state-licenses-dash">-</label>
        <div class="jd__section__container" *ngIf="stateLicenses?.length > 0">
            <ng-container *ngFor=" let stateLicense of stateLicenses; let i=index">
                <label [attr.data-qa-id]="'locums-state-licenses-label-' + i">
                    {{ stateLicense.name }}
                </label>
                <label class="jd__section__emphasized" [attr.data-qa-id]="'locums-state-licenses-details-' + i">
                    {{ getStateLicenseDetails(stateLicense) }}
                </label>
            </ng-container>
        </div>
    </div>
</div>
